module.exports = "<div class=\"py-4\"><todo-contact contact=\"$ctrl.item.record\"></todo-contact></div>";